export enum UtmParamKey {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_CONTENT = 'utm_content',
  UTM_TERM = 'utm_term',
  UTM_ID = 'utm_id',
  GCLID = 'gclid',
  ATTRIBUTED_AT = 'attributed_at',
}

export type UtmParams = {
  [UtmParamKey.UTM_SOURCE]?: string;
  [UtmParamKey.UTM_MEDIUM]?: string;
  [UtmParamKey.UTM_CAMPAIGN]?: string;
  [UtmParamKey.UTM_CONTENT]?: string;
  [UtmParamKey.UTM_TERM]?: string;
  [UtmParamKey.UTM_ID]?: string;
  [UtmParamKey.GCLID]?: string;
  [UtmParamKey.ATTRIBUTED_AT]?: string;
};
